import { useEffect, useState } from 'react'
import { Option } from '../../../models'

const imageTypeWeights = {
  '8x10': 0,
  '5x7': 600,
  '3x5': 700,
  Wallets: 900,
  File: 1000,
}

const sorter = (imageType1, imageType2) => {
  const splitName1 = imageType1.name.split(' ')
  const splitName2 = imageType2.name.split(' ')
  const weight1 = imageTypeWeights[splitName1[splitName1.length - 1]]
  const weight2 = imageTypeWeights[splitName2[splitName2.length - 1]]

  if (weight1 < weight2) return -1

  return 1
}

const useImageTypesFromOption = (optionId, numPoses = 1, filter = true) => {
  const [imageTypes, setImageTypes] = useState(null)

  useEffect(() => {
    if (!optionId) return

    Option
      .includes(['image_types'])
      .order('createdAt')
      .find(optionId)
      .then((res) => {
        const { data: { imageTypes: images } } = res
        const digitalImage = images.find((imageType) => imageType.name.toLowerCase().includes('digital'))
        const imagesWithoutDigitalImage = images.filter((imageType) => !imageType.name.toLowerCase().includes('digital'))

        if (digitalImage) {
          const digitalImgTypes = new Array(numPoses).fill(0).map(() => digitalImage)
          setImageTypes([...imagesWithoutDigitalImage, ...digitalImgTypes].sort(sorter).filter((imageType) => imageType.classname !== 'classpicture'))
        } else {
          if (!filter) setImageTypes(res.data.imageTypes.filter((imageType) => imageType.classname !== 'classpicture').sort(sorter))
          else setImageTypes(res.data.imageTypes.filter((imageType) => imageType.name !== 'Digital Files' || imageType.classname !== 'classspicture').sort(sorter))
        }
      })
  }, [optionId, numPoses])

  return imageTypes
}

export default useImageTypesFromOption
